import { type PropertyValue } from 'api/clients/PropertyClient'
import { formatDatePropertyValue } from '../utils'
import { DateFormat } from 'common/PropertyForm/Types/Date'

interface Props {
  propertyValue?: PropertyValue
  dateFormat?: DateFormat
  placeholder?: string
}

const Date = ({ propertyValue, dateFormat, placeholder }: Props) => {
  if (!propertyValue || !propertyValue.value) return <span>{placeholder}</span>

  const text = formatDatePropertyValue(propertyValue.value, dateFormat)
  return <span title={text}>{text}</span>
}

export default Date
